jQuery(function($) {
  $('#mobile-menu').click(function(){
    $('header').toggleClass('mobile-active');

    if($('header').hasClass('mobile-active')) {
      $('body, html').css('overflow-y', 'hidden');
    } else {
      $('body, html').css('overflow-y', 'auto');
    }
  });

  var itemHasChildren = $('.menu-item-has-children');
  itemHasChildren.append('<span class="expand-child-items"><svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.33013 9.02533L3.61046 4.30566L2.5498 5.36632L8.33013 11.1467L14.1105 5.36632L13.0498 4.30566L8.33013 9.02533Z" fill="#033F39"/></svg></span>')

  $('.expand-child-items').click(function () {
    $(this).toggleClass('active');
    $(this).parent('.menu-item-has-children').find('ul').first().toggleClass('active');
  });
});